<template>
  <div class="notification mk-container">
    <div class="pgnnp-header">
      <Paganiniplus />
    </div>
    <Breadcrumbs />
    <Transition name="fade" mode="out-in">
      <div v-if="isLoaded" class="container--notification">
        <div class="top-side">
          <div class="top-title-text">
            {{ $t('MEMBER.NOTIFICATION.LIST') }}
          </div>
        </div>
        <div class="center">
          <div class="list">
            <div v-if="notificationList.length > 0">
              <!--  -->
              <!--  -->
              <!--  -->
              <Paganiniplus />
            </div>
            <div v-else class="no-notification">
              <CommonEmptyContent :locale-key="'MEMBER.NOTIFICATION.NO_NOTIFICATIONS'" />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="container--loader">
        <Loader :loading="!isLoaded" />
      </div>
    </Transition>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import Paganiniplus from '@/components/tsp/Paganiniplus'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import CommonEmptyContent from '@/components/common/DummyStatus/CommonEmptyContent'

export default {
  name: 'Notification',
  components: {
    Loader,
    Breadcrumbs,
    CommonEmptyContent,
    Paganiniplus
  },
  directives: {},
  props: {},
  data() {
    return {
      isLoaded: false,
      notificationList: undefined
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ]
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    profile() {
      return this.$store.state.user.profile
    },
    title() {
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      return `${this.$t('MEMBER.NOTIFICATION.TITLE')} | ${productionLocaleName} | MUZIK AIR`
    },
    description() {
      return this.$t('MEMBER.NOTIFICATION.TITLE')
    },
    keywords() {
      return this.$t('MEMBER.NOTIFICATION.TITLE')
    },
    cover() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const coverPath = this.$production.toLowerCase()
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
    },
    canonicalURL() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/notification/${this.profile.id}`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/notification/${this.profile.id}`
    }
  },
  watch: {},
  created() {
    const userId = this.$route.params.id
    if (this.isAuthenticated && this.profile.id === userId) {
      this.getNotificationList().then(res => {
        this.notificationList = res
        this.isLoaded = true
      })
    } else {
      this.$router.push(`/${this.$i18n.localePath()}`)
    }
  },
  mounted() {
  },
  updated() {},
  methods: {
    getNotificationList() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve([])
        }, 500)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.notification {
  .pgnnp-header {
    margin-top: 24px;
  }
  .container--loader {
    display: block;
    min-height: 200px;
    margin: 24px auto;
    text-align: center;
  }
  .container--notification {
    min-height: 200px;
    margin: 24px 0;
    font-size: 16px;
    color: #7b7b7b;
  }
  .top-side {
    margin-bottom: 24px;
  }
  .center {
    position: relative;
    overflow: hidden;
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .left-side {
    position: relative;
    overflow: hidden;
    margin-right: 24px;
    float: left;
    width: calc(100% - 322px - 24px);
  }
  .right-side {
    position: relative;
    overflow: hidden;
    width: 322px;
    > div {
      margin-bottom: 24px;
    }
  }
  .top-title-text {
    display: block;
    height: 32px;
    padding-left: 68px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
  }
}

@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .container--notification {
    margin: 20px 0;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .notification {
    .container--notification {
      margin: 20px 0;
    }
    .left-side {
      display: block;
      width: 100%;
    }
    .right-side {
      display: none;
    }
    .top-title-text {
      padding-left: 0;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .notification {
    .container--notification {
      margin: 20px 0;
    }
    .left-side {
      display: block;
      width: 100%;
    }
    .right-side {
      display: none;
    }
    .top-title-text {
      padding-left: 0;
    }
  }
}

@media only screen and (max-width: 368.98px) {
  .pgnnp-header {
    margin: 0 -24px;
  }
}
</style>
